// For full API documentation, including code examples, visit https://wix.to/94BuAAs

import { listEvents, listAllEvents } from 'backend/calendar';

$w.onReady(function () {
	// listEvents("f2547pnvqrt6i45cvd843ku4kg@group.calendar.google.com").then(events => {
	//     console.log(events);
	// 	$w("#calendar").postMessage(events);
	// })
	// .catch(error => {
	// 	console.log(error);
	// // });
	listAllEvents().then(e => {
		console.log(e);
		$w("#calendar").postMessage(e);
	});
		// $w("#calendar").postMessage([{
        //         name: "Test Name",
        //         start: new Date(),
        //         end: new Date(),
        //         color: "#000",
        //         timed: true,
        //       }]);
});